module.exports = [{"name":"PRIME_PRT1555D","version":1},{"name":"PRIME_PRT1349D","version":1},{"name":"prime_prt1555","version":2}]